export const oneOfConstants = 1

export const outputDateFormat = 'DD.MM.YYYY'

export const API_DOMEN = process.env.REACT_APP_API_URL!.replace('/api', '')
